// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"688":"bcb71649","787":"4ad163ca"}[chunkId] + ".chunk.js";
};